import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useController } from "../assets/components/BaseContrroler";

const individualityItems = [
  { title: "Chronological development" },
  { title: "A total creative journey to reach the goal" },
  { title: "Modern and artistic group behavior" },
  { title: "Proper combination of man, machine & service" },
  { title: "Passion for work in a participatory manner" },
  { title: "Meeting the deadline ensuring the desired quality" },
  { title: "Meeting the objectives of given assignment" },
];

function Individuality() {
  const {
    baseController: { homeController },
  } = useController();
  const { setNavbar, setUrl } = homeController;

  useEffect(() => {
    setUrl("/individuality");
    setNavbar(true);
  }, [setNavbar, setUrl]);

  return (
    <Box>
      <div className="row ps-1" id="individuality">
        <div className="col-lg-12">
          <section className="todo text-center" id="whatwedo">
            {/* Keep your same top image */}
            <div>
              <img
                src={require("../assets/images/individuality.png")}
                alt="karnafully"
                className="ind-top-image img-fluid"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </div>

            <div className="row mt-3">
              <div className="col-lg-12 m-auto">
                <div className="list3container text-white">
                  <div className="row g-3">
                    {individualityItems.map((item, i) => (
                      <div
                        className="col-12 col-sm-6 text-dark text-start fw-bold"
                        key={i}
                      >
                        <span className="bold-circle m-1"></span>
                        {item.title}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Box>
  );
}

export default observer(Individuality);
